import React from 'react';

import { useDispatch, useSelector } from 'bundles/research/index/store/hooks';
import { switchTab } from 'bundles/research/index/store/actions/ui';

import Toggle from 'bundles/research/index/components/toggle';
import {
  faLocationDot,
  faTableLayout,
} from '@fortawesome/pro-regular-svg-icons';

export default function ViewToggle() {
  const currentTab = useSelector(state => state.ui.currentTab);
  const dispatch = useDispatch();

  return (
    <Toggle
      options={[
        { label: 'Map View', value: 'maps', icon: faLocationDot },
        { label: 'Table View', value: 'properties', icon: faTableLayout },
      ]}
      value={currentTab}
      onChange={value => dispatch(switchTab(value))}
    />
  );
}
